import { Flex, ThemeUIStyleObject } from 'theme-ui';
import Marquee from 'react-fast-marquee';
import ImgLoader from '../ImgLoader';
import { Image } from '~/types';

type Props = {
  images: Image[];
  autoFill?: boolean;
  pauseOnHover?: boolean;
  forwardSX?: ThemeUIStyleObject;
};
const MarqueeImage = ({ images, pauseOnHover = true, forwardSX = {} }: Props) => {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'space-evenly',

        ...forwardSX,
      }}
    >
      <Marquee pauseOnHover={pauseOnHover}>
        {images.map((image) =>
          image ? <ImgLoader key={image.title} image={image} alt={`${image.title}'s logo`} sx={{ mx: '2rem' }} /> : null
        )}
      </Marquee>
    </Flex>
  );
};

export default MarqueeImage;
